module.exports = __webpack_public_path__ + "img/kbsa_thumb.8ae6b6ec.gif";